import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';
import { SystemLogTypeOption } from '../system-logs-type-option.interface';

export const systemLogTypeOptionActions = createEagerSelectActions<SystemLogTypeOption>('[System Log Type Options]');
